// Dashboard page component

import Alpine from 'alpinejs';
import { getDB } from '../storage/db.js';

Alpine.data('dashboardPage', () => ({
  meetings: [] as any[],
  filter: 'all',
  isLoading: true,

  async init() {
    await this.loadMeetings();
  },

  async loadMeetings() {
    try {
      this.isLoading = true;
      const db = await getDB();
      const tx = db.transaction('meetings', 'readonly');
      const store = tx.objectStore('meetings');
      
      const request = store.getAll();
      this.meetings = await new Promise((resolve, reject) => {
        request.onsuccess = () => resolve(request.result || []);
        request.onerror = () => reject(request.error);
      });
      
      // Sort by updated_at descending (newest first)
      this.meetings.sort((a: any, b: any) => {
        return new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime();
      });
      
      console.log('✅ Loaded meetings:', this.meetings.length);
    } catch (error) {
      console.error('Error loading meetings:', error);
      this.meetings = [];
    } finally {
      this.isLoading = false;
    }
  },

  get filteredMeetings() {
    if (this.filter === 'all') return this.meetings;
    return this.meetings.filter((m: any) => m.status === this.filter);
  },

  translateStatus(status: string): string {
    const translations: Record<string, string> = {
      'draft': 'Borrador',
      'planned': 'Planificada',
      'running': 'En curso',
      'done': 'Finalizada',
      'archived': 'Archivada',
    };
    return translations[status] || status;
  },

  formatDate(dateStr: string): string {
    if (!dateStr) return '';
    return new Date(dateStr).toLocaleDateString('es-ES');
  },

  openMeeting(id: string) {
    window.location.href = `/meeting/${id}`;
  },

  createMeeting() {
    window.location.href = '/prepare';
  },
}));

